"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINRadioInput = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var PINOption_1 = require("./PINOption");
var PINInput_1 = require("./PINInput");
var PINRadioInput = /** @class */ (function (_super) {
    __extends(PINRadioInput, _super);
    function PINRadioInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: null,
            value: _this.props.value || _this.props.defaultValue || null
        };
        _this.options = PINOption_1.retrieveOptions(_this.props.children, _this.props.options);
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        _this.getValueOnChange = function (event) {
            _this.setState({ value: event.target.value });
            return event.target.value;
        };
        return _this;
    }
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
    PINRadioInput.prototype.componentWillReceiveProps = function (props) {
        this.options = PINOption_1.retrieveOptions(props.children, props.options);
    };
    // @ts-expect-error ts-migrate(2416) FIXME: Property 'render' in type 'PINRadioInput' is not a... Remove this comment to see the full error message
    PINRadioInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, required = _a.required, hiddenRequired = _a.hiddenRequired, name = _a.name, id = _a.id, inline = _a.inline;
        return (React.createElement("div", { className: "pinradioinput " + (this.props.className ? this.props.className : "") },
            React.createElement("div", { className: "pinradioinput-label" },
                (required && !hiddenRequired) && "* ",
                this.props.label || ""),
            this.options.map(function (option, index) { return (React.createElement("div", { key: "pinradioinput" + index + option.label + option.value, style: { display: inline ? "inline-block" : "block" }, className: "pinradioinput-option" + (inline ? " mr-md" : "") },
                React.createElement("input", { className: "pinradioinput-option-input", type: "radio", id: (id || name) + index, name: name, value: option.value, onChange: _this.onChange, checked: JSON.stringify(_this.state.value) === JSON.stringify(option.value) }),
                React.createElement("label", { className: "pinradioinput-option-label", htmlFor: (id || name) + index }, option.label))); })));
    };
    PINRadioInput.className = "PINRadioInput";
    PINRadioInput.propTypes = __assign(__assign({}, PINInput_1.PINInput.propTypes), { options: PropTypes.arrayOf(PropTypes.shape(PINOption_1.PINOption.propTypes)), focused: PropTypes.bool, inline: PropTypes.bool });
    return PINRadioInput;
}(PINInput_1.PINInput));
exports.PINRadioInput = PINRadioInput;
//# sourceMappingURL=PINRadioInput.js.map